import { render } from "./pagePagination.vue?vue&type=template&id=af3f6f3e&scoped=true"
import script from "./pagePagination.vue?vue&type=script&lang=js"
export * from "./pagePagination.vue?vue&type=script&lang=js"

import "./pagePagination.vue?vue&type=style&index=0&id=af3f6f3e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3f6f3e"]])

export default __exports__